export const organizationEndpoints = {
  getMessageBrokerMultiaddr: (id: string) => `/private/v1/organizations/${id}/messageBroker-multiaddr`,
} as const;

export type OrganizationEndpointKey = keyof typeof organizationEndpoints;
